// The numbered fields of the in-game „prawo jazdy" (laid out like the Polish card: 1 surname,
// 2 name, 4a issued, 4b expires, 4c issuer, 4d personal number, 5 licence number, 9 category).
// Pure, so `node --test` covers the formatting; LicenceModal draws them.

const VALID_YEARS = 15;   // a category-B licence is issued for 15 years

const pad = (n, w) => String(n).padStart(w, '0');
const dmy = (d) => `${pad(d.getDate(), 2)}.${pad(d.getMonth() + 1, 2)}.${d.getFullYear()}`;

/** A 12-char letters+digits key from any string — the document numbers, stable per player. */
function digitsFrom(text, count) {
  let h = 2166136261;
  for (const ch of String(text)) h = Math.imul(h ^ ch.charCodeAt(0), 16777619) >>> 0;
  let out = '';
  while (out.length < count) { out += String(h % 10); h = Math.floor(h / 10) || (h + 7919) * 31; }
  return out;
}

/**
 * `name` is the player's one name (the game has no surnames — it goes on line 1 in
 * capitals, and line 2 repeats it as written); `licenceIso` the server's licence_iso;
 * `playerId` seeds the document numbers.
 */
export function licenceFields({ name = 'Kierowca', licenceIso = null, playerId = '' } = {}) {
  const issued = licenceIso ? new Date(licenceIso) : null;
  const expires = issued ? new Date(issued.getFullYear() + VALID_YEARS, issued.getMonth(), issued.getDate()) : null;
  const seed = `${name}|${playerId}`;
  return {
    surname: String(name).toLocaleUpperCase('pl-PL'),
    name: String(name),
    issued: issued ? dmy(issued) : '—',
    expires: expires ? dmy(expires) : '—',
    issuer: 'WÓJT MIASTECZKA',
    personalNo: digitsFrom(seed, 11),
    licenceNo: `MG${digitsFrom(`${seed}#`, 5)}/24/B`,
    category: 'B',
  };
}
